/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CommonGeoJsonProperties } from './CommonGeoJsonProperties';

export type api_eoi_server__economics_v2__common_geojson_properties__Feature = {
    id?: (string | number);
    type: api_eoi_server__economics_v2__common_geojson_properties__Feature.type;
    geometry?: any;
    properties: CommonGeoJsonProperties;
};

export namespace api_eoi_server__economics_v2__common_geojson_properties__Feature {

    export enum type {
        FEATURE = 'Feature',
    }


}

